<template>
  <div>
    <page-header
      :title="userInfo.full_name"
      :avatar="userInfo.avatar_preview"
    />
    <form-wrapper
      ref="form"
      :service="Auth"
      :formComponent="InnerForm"
      :form.sync="form"
      :errors.sync="errors"
      :objParams="$store.state.userInfo.id"
      class="c-box"
    />
  </div>
</template>
<script>
import { Auth } from '@/api'
import InnerForm from './InnerForm'

export default {
  data() {
    return {
      InnerForm,
      Auth,
      form: {},
      errors: {}
    }
  }
}
</script>
